// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__8GFZy","titleWrapper":"styles_titleWrapper__JawQ6","infoIcon":"styles_infoIcon__if2HO","townInfo":"styles_townInfo__yxRAb","endeksaAbout":"styles_endeksaAbout__HqCkw","endeksaRedirect":"styles_endeksaRedirect__1FcHt"};
module.exports.__checksum = "193a6aeb0277"
